import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentMultiVerifyIdentityData,
  type EnrollmentMultiVerifyIdentitySubmitOutput,
} from '../../../../models'

export const getEnrollmentMultiVerifyIdentityDataMock: EnrollmentMultiVerifyIdentityData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/verify-identity',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentMultiVerifyIdentityDataMock: EnrollmentMultiVerifyIdentitySubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/multi/employment',
}

export const mockGetEnrollmentMultiVerifyIdentityData = graphql.mutation('getEnrollmentMultiVerifyIdentityData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentMultiVerifyIdentityDataMock } })
})

export const mockSubmitEnrollmentMultiVerifyIdentityData = graphql.mutation(
  'submitEnrollmentMultiVerifyIdentityData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentMultiVerifyIdentityDataMock } })
  },
)

export const mockEnrollmentMultiVerifyIdentity = [
  mockGetEnrollmentMultiVerifyIdentityData,
  mockSubmitEnrollmentMultiVerifyIdentityData,
]
